import {
  GET_ALL_CASHIERS,
  GET_ALL_CASHIERS_RESPONSE_SUCCESS,
  CREATE_CASHIER,
  UPDATE_CASHIER,
  DELETE_CASHIER,
} from "./actionTypes"

export const getAllCashiers = () => {
  return {
    type: GET_ALL_CASHIERS,
  }
}
export const getAllCashiersResponseSuccess = payload => ({
  type: GET_ALL_CASHIERS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createCashier = (payload, history) => {
  return {
    type: CREATE_CASHIER,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateCashier = (payload, history, id) => {
  return {
    type: UPDATE_CASHIER,
    payload: payload,
    history,
    id,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteCashier = payload => ({
  type: DELETE_CASHIER,
  payload: payload,
})
